<template>
  <div style="height: 100%; background-color: #FFF;">
    <el-card>
      <div slot="header" style="text-align: center;" class="clearfix">
        <span>{{title}}</span>
      </div>
      <el-form :model="proInfo" :rules="rules" ref="proInfo">
        <el-tabs v-model="activeName"  >
          <el-tab-pane label="产品信息" name="first" :disabled="tabFirstDisabled">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="业务系统:" prop="sysId" :required="off"  :label-width="formLabelWidth">
                    <el-select  v-model="proInfo.sysId" @change="changeSys" clearable filterable  placeholder="请选择业务系统">
                      <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产品名称:" prop="proName" :required="off"  :label-width="formLabelWidth">
                    <el-input style="width: 217px;" maxlength="50" clearable v-model="proInfo.proName"  auto-complete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="产品英文名称:" prop="proEngName" :required="off"  :label-width="formLabelWidth">
                    <el-input style="width: 217px;" maxlength="50" clearable v-model="proInfo.proEngName" auto-complete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="产品类型:" prop="proType" :required="off"  :label-width="formLabelWidth">
                    <el-select  v-model="proInfo.proType" filterable clearable placeholder="请选择产品类型">
                      <el-option :label="item.prodTypeNameCn" :value="item.prodTypeId" v-for="(item, $index) in typeData" :key="$index"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="产品状态:" prop="proState" :required="off"  :label-width="formLabelWidth">
                    <el-select  v-model="proInfo.proState" clearable filterable  placeholder="请选择产品状态">
                      <el-option  label="启用" value="false" ></el-option>
                      <el-option  label="禁用" value="true" ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item label="是否缓存:" prop="proCache" :required="off"  :label-width="formLabelWidth">
                    <el-select @change="selectCache" clearable v-model="proInfo.proCache" filterable  placeholder="请选择是否缓存">
                      <el-option  label="是" value="true" ></el-option>
                      <el-option  label="否" value="false" ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="缓存超时时间:" prop="time"  :label-width="formLabelWidth">
                    <el-input style="width: 217px;" maxlength="4" clearable :disabled="timeDisabled" v-model="proInfo.time" auto-complete="off"></el-input>
                    <span class="ml">(h)</span>
                  </el-form-item> -->
                </el-col>
                <el-col :span="12">
                  <el-form-item  label="是否需要告警:" prop="proAlarm" :required="off"  :label-width="formLabelWidth">
                    <el-select @change="selectAlarm" v-model="proInfo.proAlarm" clearable filterable  placeholder="请选择是否需要告警">
                      <el-option  label="需要" value="true" ></el-option>
                      <el-option  label="不需要" value="false" ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="选择告警通道:" :label-width="formLabelWidth">
                    <el-checkbox-group :disabled="alarmDisabled" clearable v-model="proInfo.alarmPath">
                      <el-checkbox label="短信" name="type"></el-checkbox>
                      <el-checkbox label="邮箱" name="type"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="告警超时时间:" prop="alarmTime" :required="off"  :label-width="formLabelWidth">
                    <el-input style="width: 217px;" maxlength="9" clearable v-model="proInfo.alarmTime" auto-complete="off"></el-input>
                    <span class="ml">(ms)</span>
                  </el-form-item>
                  <el-form-item label="产品超时时间:" prop="proTimeout" :required="off"  :label-width="formLabelWidth">
                    <el-input style="width: 217px;" maxlength="9" clearable v-model="proInfo.proTimeout" auto-complete="off"></el-input>
                    <span class="ml">(ms)</span>
                  </el-form-item>
                  <el-form-item label="备注:" :label-width="formLabelWidth">
                    <el-input type="textarea" style="width: 217px;" clearable maxlength="150" v-model="proInfo.desc"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item style="textAlign: center;">
                <el-button @click="returnPro">关闭</el-button>
                <el-button type="primary" @click="submitForm('proInfo')" v-show="editSure">确 定</el-button>
                <el-button type="primary" @click="addForm('proInfo')" v-show="!editSure">确 定</el-button>
              </el-form-item>
              <div class="mt"></div>
          </el-tab-pane>
          <el-tab-pane label="关联计费字段" :disabled="tabDisabled"  name="fource">
            <el-form
              ref="proBillFiled"
              :model="proBillFiled"
              label-width="120px">
              <el-button
                size="small"
                type="primary"
                plain
                @click="addBillFiled"
              >新增计费字段</el-button>
              <div
                v-for="(item, index) in proBillFiled.billFiledData"
                :key="index"
                class="clearfix">
                <el-col :span="18">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item
                        label="计费字段"
                      >
                        <el-select
                          v-model="item.fieldId"
                          placeholder="请选择计费字段"
                          style="width:100%"
                        >
                          <el-option
                            v-for="(val, $index) in filedData"
                            :key="$index"
                            @click.native="changeFleld(val.fieldId, index)"
                            :label="val.fieldName"
                            :value="val.fieldId"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="11" :offset="2">
                      <el-input  disabled v-model="item.fieldExp" ></el-input>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="3" :offset="1">
                  <el-button
                    class="float-r"
                    size="small"
                    icon="el-icon-delete"
                    @click.prevent="removeBillFiled(item)"
                    title="删除"
                  ></el-button>
                    <!-- v-show="(index == 0) ? false : true" -->
                </el-col>
              </div>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="returnPro">关闭</el-button>
                <el-button
                  type="primary"
                  @click="saveFiled"
                >确定</el-button>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="产品定价" :disabled="tabDisabled" name="second">
              <div class="line" v-show="showRule">
                <Rule :data="priceRule" @getRule="queryRule($event)" ></Rule>
                <div style="margin-left: 120px;">
                  <valuationTemplate1
                    :singleData="singleData"
                    :billFiledData ="copyFieldData"
                    v-on:changeFlag="changeFlag($event)"
                    v-on:addInputParams="addInputParams"
                    v-on:removeInputParams="removeInputParams($event)"
                    @addGroup="addFiledGroup($event)"
                    v-on:removeGroup="removeGroup($event)"
                    v-if="priceRule.strategyId === '20171020110707_Yr2r1x61_1000002'"
                  ></valuationTemplate1>
                  <valuationTemplate2
                    :amountData="amountData"
                    :billFiledData ="copyFieldData"
                    v-on:addSection="addSection"
                    v-on:removeSection="removeSection"
                    v-on:addConfigure="addConfigure"
                    v-on:removeConfigure="removeConfigure"
                    v-else-if="priceRule.strategyId === '20171020110707_Yr2r1x61_1000001' || priceRule.strategyId === '20171020110707_Yr2r1x61_1000000'"
                  ></valuationTemplate2>
                  <valuationTemplate3
                    :packetData="packetData"
                    :billFiledData ="copyFieldData"
                    v-on:addpacketSection="addpacketSection"
                    v-on:removepacketSection="removepacketSection"
                    v-on:addpacketConfigure="addpacketConfigure"
                    v-on:removepacketConfigure="removepacketConfigure"
                    v-else-if="priceRule.strategyId ==='20171020110707_Yr2r1x61_1000003'"
                  ></valuationTemplate3>
                </div>
                <div style="textAlign: center; margin-top: 20px;">
                  <el-button  @click="returnPro" >关闭</el-button>
                  <el-button type="primary" @click="addRule" >确 定</el-button>
                </div>
              </div>
            <!-- </el-form> -->
          </el-tab-pane>
          <el-tab-pane label="关联通道" :disabled="tabDisabled" name="third">
            <el-form-item label="关联通道组:" :label-width="formLabelWidth" v-show="path">
              <el-button type="primary" @click="relatedPath" >添加通道组</el-button>
            </el-form-item>
            <pro-path
              v-on:httpChannel="httpChannel($event)"
              v-on:httpGroup="httpGroup($event)"
              v-on:editGroup="editPathGroup($event)"
              v-on:editChannel="editChannelPath($event)"
              v-on:addChannel="addChannelPath($event)"
              v-on:delChannel="delChannel($event)"
              v-on:delGroup="delGroup($event)"
              v-on:changeFun="changeFun($event)"
              v-on:reletedCusGroup="reletedCusGroup($event)"
              :pathTable ="pathTable"
              :pipeIdList="pipeIdList"
              :prodId ="prodId"
              v-show="path"
              >
            </pro-path>
            <el-pagination
              v-show="path"
              class="mt"
              background
              @size-change="handleSizeChange"
              :current-page="currentPage"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="page"
              layout="total, sizes, prev, pager, next"
              :total="total">
            </el-pagination>
            <el-form-item style="textAlign: center;">
              <el-button @click="returnPro">关闭</el-button>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <el-dialog @close="close" :title="pathTitle" width="450px" center :modal-append-to-body='false' :visible.sync="pathDialog" >
        <el-form :model="pathInfo" :rules="pathRule" ref="pathInfo">
          <el-form-item label="通道名称:" prop="pipeId" :required="off"  :label-width="formLabelWidth">
            <el-select  v-model="pathInfo.pipeId" :name="pathInfo.pipeName" filterable clearable placeholder="请选择通道名称">
              <el-option @click.native="slectPath(item)" :label="item.pipeName" :value="item.pipeId" v-for="(item, $index) in pipeIdList" :key="$index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联状态:" prop="active" :required="off"  :label-width="formLabelWidth">
            <el-select  v-model="pathInfo.active" clearable filterable  placeholder="请选择状态">
              <el-option label="启用" value="1" ></el-option>
              <el-option label="停用" value="0" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道类型:" prop="pipeType" :required="off"  :label-width="formLabelWidth">
            <el-select  v-model="pathInfo.pipeType" @change="pipeChange" clearable filterable  placeholder="请选择通道类型">
              <el-option label="默认" value="0" ></el-option>
              <el-option label="前置" value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权重:" prop="ratio"   :label-width="formLabelWidth">
            <el-input style="width: 217px;"  oninput="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}"
            onpaste="if(!/(^0$)|(^100$)|(^\d{1,2}$)/.test(value)){value=''}" :disabled="ratioDisabled" clearable v-model.number="pathInfo.ratio" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="连接超时时间:" prop="conTimeout" :required="off"  :label-width="formLabelWidth">
            <el-input style="width: 217px;" maxlength="9" clearable v-model="pathInfo.conTimeout" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="读取超时时间:" prop="soTimeout" :required="off"  :label-width="formLabelWidth">
            <el-input style="width: 217px;" maxlength="9" clearable v-model="pathInfo.soTimeout" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item style="textAlign: center;">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" v-show="reletedPath" @click="addPath('pathInfo')">确 定</el-button>
            <el-button type="primary" v-show="!reletedPath" @click="editPath('pathInfo')">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog @close="closeGroup" :title="pathGroupTitle" width="450px" center :modal-append-to-body='false' :visible.sync="pathGroupDialog">
        <el-form :model="pathGroupInfo" :rules="pathGroupRule" ref="pathGroupInfo">
          <el-form-item label="通道组名称:" prop="groupName"  :required="off" :label-width="formLabelWidth">
            <el-input style="width: 217px;"  :disabled="groupNameDisabled" maxlength="20" clearable v-model="pathGroupInfo.groupName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="通道组状态:" prop="state" :required="off"  :label-width="formLabelWidth">
            <el-select  v-model="pathGroupInfo.state" clearable filterable  placeholder="请选择通道组状态">
              <el-option label="启用" value="1" ></el-option>
              <el-option label="禁用" value="0" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否缓存:"   :label-width="formLabelWidth">
            <el-select  clearable :disabled="cachedDisabled" v-model="pathGroupInfo.cached" filterable  placeholder="请选择是否缓存">
              <el-option  label="是" value="true" ></el-option>
              <el-option  label="否" value="false" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="通道组描述:" :label-width="formLabelWidth">
            <el-input type="textarea" style="width: 217px;" clearable maxlength="100" v-model="pathGroupInfo.groupDesc"></el-input>
          </el-form-item>
          <el-form-item style="textAlign: center;">
            <el-button @click="pathGroupDialog=false">取 消</el-button>
            <el-button type="primary" v-show="reletedGroup" @click="addGroup('pathGroupInfo')">确 定</el-button>
            <el-button type="primary" v-show="!reletedGroup" @click="editGroup('pathGroupInfo')">确 定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog >
      <el-dialog title="已关联客户" width="450px" center :modal-append-to-body='false' :visible.sync="releteGroupDialog">
        <el-table
          :data="CusGroupData"
          style="width: 100%">
          <el-table-column
            label="客户ID"
            :show-overflow-tooltip="tooltip"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.custId }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="客户名称"
            :show-overflow-tooltip="tooltip"
            width="">
            <template slot-scope="scope">
              <span >{{ scope.row.custName }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
.clearfix {
  @include clearfix;
}
.mt {
  margin: 22px;
}
.line {
  border: 1px solid #00c2de;
  padding: 22px 0;
}
.info-title {
  font-weight: bolder;
  margin-bottom: 22px;
}
</style>
<script>
import Rule from './rule'
import proPath from './path/addPath.vue'
import valuationTemplate1 from '../valuation/valuationTemplate1.vue'
import valuationTemplate2 from '../valuation/valuationTemplate2.vue'
import valuationTemplate3 from '../valuation/valuationTemplate3.vue'
import valuationTemplate4 from '../valuation/valuationTemplate4.vue'
export default {
  name: 'addProMain',
  data () {
    return {
      ratioDisabled: false,
      tabDisabled: true,
      currentPage: 1,
      page: 10,
      tooltip: true,
      tabFirstDisabled: false,
      pathDialog: false,
      pathTitle: '',
      pathGroupTitle: '',
      pathGroupDialog: false,
      reletedGroup: true,
      releteGroupDialog: false,
      CusGroupData: [],
      form: {
        sysData: [],
        typeData: []
      },
      typeData: [],
      index: '', // 通道组关联通道的下标
      channelIndex: '', // 通道组下标
      reletedPath: true,
      pathInfo: {
        soTimeout: '',
        conTimeout: '',
        ratio: '',
        pipeType: '',
        active: '',
        pipeId: '',
        pipeName: ''
      },
      proInfo: {
        sysId: '',
        proName: '',
        proEngName: '',
        proType: '',
        proState: '',
        proCache: '',
        time: '',
        proAlarm: '',
        alarmPath: [],
        alarmTime: '',
        proTimeout: '',
        desc: ''
      },
      cachedDisabled: false,
      groupNameDisabled: false,
      groupId: '', // 通道组id
      pathGroupInfo: {
        groupName: '',
        state: '',
        cached: '',
        groupDesc: ''
      },
      priceRule: {
        strategy: [],
        strategyId: '',
        rule: [],
        ruleId: '',
        ruleNameCn: '',
        ruleNameEn: '',
        disabled: true,
        billArr: [
          {
            billKeyWord: '',
            billParamName: '',
            billKeyWordType: ''
          }
        ]
      },
      activeName: 'first',
      showRule: false,
      related: false,
      num: '',
      size: '',
      path: false,
      rules: {
        proName: [
          { required: true, message: '请输入产品名称', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        proEngName: [
          { required: true, message: '请输入产品英文名称', trigger: ['blur', 'change'] },
          { validator: this.regular.englishName, trigger: ['blur', 'change'] }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        proType: [
          { required: true, message: '请选择产品类型', trigger: 'change' }
        ],
        proState: [
          { required: true, message: '请选择产品状态', trigger: 'change' }
        ],
        proCache: [
          { required: true, message: '请选择是否缓存', trigger: 'change' }
        ],
        proAlarm: [
          { required: true, message: '请选择是否需要告警通道', trigger: 'change' }
        ],
        alarmTime: [
          { required: true, message: '请输入告警时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        time: [
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        proTimeout: [
          { required: true, message: '请输入产品超时时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ]
      },
      pathRule: {
        conTimeout: [
          { required: true, message: '请输入连接超时时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        ratio: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                callback(new Error('请填写大于0的数字'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          },
          trigger: 'change',
          required: false
        }],
        soTimeout: [
          { required: true, message: '请输入读取超时时间', trigger: ['blur', 'change'] },
          { validator: this.regular.greaterThanZero, trigger: ['blur', 'change'] }
        ],
        pipeId: [
          { required: true, message: '请选择通道名称', trigger: 'change' }
        ],
        active: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
        pipeType: [
          { required: true, message: '请选择通道类型', trigger: 'change' }
        ]
      },
      pathGroupRule: {
        groupName: [
          { required: true, message: '请输入通道组名称', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        state: [
          { required: true, message: '请选择通道组状态', trigger: 'change' }
        ]
      },
      singleData: {
        inputParamsPricing: {
          inputParamsPricingFlag: false
          // pricingunit: [
          //   {
          //     key: '',
          //     value: ''
          //   }
          // ]
        },
        outputParamsPricings: [
          {
            outputParamsPricing: {
              pricing: [
                {
                  type: '', // 等于大于那列
                  key: '',
                  value: ''
                }
              ],
              price: ''
            }
          }
        ]
      },
      amountData: { // 金额 调用 规则数据
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              start: '',
              end: '',
              price: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      },
      packetData: { // 包时段
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              // start: '2019-01-22',
              // end: '2019-01-25',
              time: [], // 需要把start和end合并到time数组
              price: '',
              expectPrice: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      },
      proBillFiled: {
        billFiledData: [
        ]
      },
      pipeIdList: [],
      copyFieldData: [],
      filedData: [],
      copypipeIdList: [],
      // pathTable: [],
      editSure: true,
      off: true,
      title: '',
      timeDisabled: false,
      alarmDisabled: false,
      formLabelWidth: '120px'
    }
  },
  computed: {
    // typeData () {
    //   return this.$store.state.productType
    // },
    sysData () {
      return this.$store.state.sysData
    },
    prodId () {
      return this.$store.state.addPromain.prodId
    },
    pathTable () {
      return this.$store.state.addPromain.table
    },
    total () {
      return this.$store.state.addPromain.total
    }
  },
  components: {
    Rule,
    proPath,
    valuationTemplate1,
    valuationTemplate2,
    valuationTemplate3,
    valuationTemplate4
  },
  methods: {
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.queryPath(this.prodId)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryPath(this.prodId)
    },
    changeFlag (val) { // 单次计价 切换是否入参
      if (val) {
        this.singleData.inputParamsPricing.inputParamsPricingFlag = true
        this.singleData.inputParamsPricing.pricingunit = []
        let op = {}
        op.key = ''
        op.value = ''
        this.singleData.inputParamsPricing.pricingunit.push(op)
        this.singleData.inputParamsPricing = Object.assign({}, this.singleData.inputParamsPricing)
      } else {
        this.singleData.inputParamsPricing.inputParamsPricingFlag = false
      }
    },
    addInputParams () { // 单次计价 新增入参
      console.log(this.singleData.inputParamsPricing.pricingunit)
      let op = {}
      op.key = ''
      op.value = ''
      this.singleData.inputParamsPricing.pricingunit.push(op)
      this.singleData.inputParamsPricing = Object.assign({}, this.singleData.inputParamsPricing) // 重新赋值 刷新
    },
    removeInputParams (index) { // 单次计价 删除入参
      if (this.singleData.inputParamsPricing.pricingunit.length !== 0 && this.singleData.inputParamsPricing.pricingunit.length !== 1) {
        this.singleData.inputParamsPricing.pricingunit.splice(index, 1)
      }
    },
    addFiledGroup (op) { // 单次计价 新增计价表
      this.singleData.outputParamsPricings.push(op)
    },
    removeGroup (index) { // 单次计价 删除计价表
      if (this.singleData.outputParamsPricings.length !== 1 && this.singleData.outputParamsPricings.length !== 0) {
        this.singleData.outputParamsPricings.splice(index, 1)
      }
    },
    addSection (op) { // 金额 调用计费 添加区间
      this.amountData.outputParamsPricings.section.push(op)
    },
    removeSection (index) { // 金额 调用计费 删除区间
      if (this.amountData.outputParamsPricings.section.length !== 1 && this.amountData.outputParamsPricings.section.length !== 0) {
        this.amountData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addConfigure (op) { // 金额 调用计费 新增计费配置
      this.amountData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removeConfigure (index) { // 金额 调用计费 删除计费配置
      if (this.amountData.outputParamsPricings.outputParamsPricing.length !== 1 && this.amountData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.amountData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    addpacketSection (op) { // 包时段
      this.packetData.outputParamsPricings.section.push(op)
    },
    removepacketSection (index) { // 包时段
      if (this.packetData.outputParamsPricings.section.length !== 1 && this.packetData.outputParamsPricings.section.length !== 0) {
        this.packetData.outputParamsPricings.section.splice(index, 1)
      }
    },
    addpacketConfigure (op) {
      this.packetData.outputParamsPricings.outputParamsPricing.push(op)
    },
    removepacketConfigure (index) {
      if (this.packetData.outputParamsPricings.outputParamsPricing.length !== 1 && this.packetData.outputParamsPricings.outputParamsPricing.length !== 0) {
        this.packetData.outputParamsPricings.outputParamsPricing.splice(index, 1)
      }
    },
    addBillFiled () {
      this.proBillFiled.billFiledData.push({
        fieldId: '',
        fieldName: '',
        fieldExp: ''
      })
    },
    /* 删除账户 */
    removeBillFiled (item) {
      var index = this.proBillFiled.billFiledData.indexOf(item)
      if (index !== -1) {
        /* 对已存在的账户删除push到另一个数组 */
        if (item.supAccountId) {
          item.isDelete = 1
          this.supAccountData2.push(item)
        }
        this.proBillFiled.billFiledData.splice(index, 1)
      }
    },
    changeFleld (val, i) {
      this.filedData.forEach((v, index) => {
        console.log(v)
        if (v.fieldId === val) {
          this.proBillFiled.billFiledData[i].fieldExp = v.fieldExpression
          this.proBillFiled.billFiledData[i].fieldName = v.fieldName
        }
      })
      console.log(this.proBillFiled.billFiledData)
    },
    changeSys (val) {
      let _this = this
      this.proInfo.proType = ''
      let arr = []
      arr.push(val)
      _this.axios({ // 请求下游计费字段
        method: 'post',
        url: _this.$API.config.queryProdChargeFieldListByPage,
        // url: 'http://172.16.9.73:5010/agw/prodChargeFieldCtr/queryProdChargeFieldListByPage',
        data: { 'pageNum': 1, 'pageSize': 50, sysIds: arr }
      }).then((response) => {
        _this.filedData = response.data.resData.resultList
      }).catch((error) => {
        console.log(error)
      })
      _this.axios({
        method: 'post',
        url: _this.$API.product.getProdTypeList,
        data: { 'pageNum': 1, 'pageSize': 50, sysIds: arr }
      }).then((response) => {
        _this.typeData = response.data.resData.resultList
      }).catch((error) => {
        console.log(error)
      })
    },
    returnPro () { // 取消返回之前产品维护
      this.$store.commit('closeTab', this.$route) // 关闭当前路由
      this.$router.push({
        name: 'proMain',
        query: {
          num: this.num,
          size: this.size
        }
      })
    },
    pipeChange (val) {
      if (val === '1') {
        this.ratioDisabled = true
        this.pathInfo.ratio = 0
      } else {
        this.ratioDisabled = false
        this.pathInfo.ratio = ''
      }
    },
    addChannelPath (index) {
      this.index = index
      console.log(this.pathTable)
      for (let v of this.pathTable[index].table) {
        this.pipeIdList.forEach((item, i) => {
          if (v.pipeId === item.pipeId) {
            this.pipeIdList.splice(i, 1)
          }
        })
      }
      let hash = {}
      this.pipeIdList = this.pipeIdList.reduce(function (item, next) { // 去掉重复的对象
        // hash[next.pipeId] ? '' : hash[next.pipeId] = true && item.push(next)
        if (!hash[next.pipeId]) {
          hash[next.pipeId] = true && item.push(next)
        }
        return item
      }, [])
      this.pathDialog = true
      this.reletedPath = true
      this.pathTitle = '通道关联'
    },
    changeFun (val) { // 切换关联通道选择
      console.log(val)
    },
    delChannel (op) {
      for (let v of op.delete) {
        let obj = {}
        obj.pipeId = v.pipeId
        obj.pipeName = v.pipeName
        this.pipeIdList.push(obj)
      }
      let hash = {}
      this.pipeIdList = this.pipeIdList.reduce(function (item, next) { // 去掉重复的对象
        // hash[next.pipeId] ? '' : hash[next.pipeId] = true && item.push(next)
        if (!hash[next.pipeId]) {
          hash[next.pipeId] = true && item.push(next)
        }
        return item
      }, [])
    },
    editChannelPath (val) {
      let op = {}
      op.pipeId = val.row.pipeId
      op.pipeName = val.row.pipeName
      this.pathInfo.soTimeout = val.row.soTimeout
      this.pathInfo.conTimeout = val.row.conTimeout
      this.pathInfo.ratio = val.row.ratio ? val.row.ratio : 0
      this.pathInfo.pipeType = val.row.pipeType + ''
      this.pathInfo.active = val.row.active + ''
      this.pathInfo.pipeId = val.row.pipeId
      this.pathInfo.pipeName = val.row.pipeName
      this.pipeIdList.push(op)
      let hash = {}
      this.pipeIdList = this.pipeIdList.reduce(function (item, next) { // 去掉重复的对象
        // hash[next.pipeId] ? '' : hash[next.pipeId] = true && item.push(next)
        if (!hash[next.pipeId]) {
          hash[next.pipeId] = true && item.push(next)
        }
        return item
      }, [])
      this.channelIndex = val.$index
      this.index = val.index
      this.pathTitle = '通道关联'
      this.pathDialog = true
      this.reletedPath = false
      console.log(this.pathInfo)
    },
    close () {
      let op = {
        soTimeout: '',
        conTimeout: '',
        ratio: '',
        pipeType: '',
        active: '',
        pipeId: '',
        pipeName: ''
      }
      this.ratioDisabled = false
      this.pathInfo = Object.assign({}, op) // 清除之前的数据
      this.$refs['pathInfo'].resetFields() // 关闭时清除验证条件
      this.pathDialog = false
    },
    closeGroup () {
      let op = {
        groupName: '',
        status: '',
        cached: '',
        groupDesc: ''
      }
      this.groupNameDisabled = false
      this.pathGroupInfo = Object.assign({}, op) // 关闭清空通道组数据
      this.$refs['pathGroupInfo'].resetFields() // 关闭时清除验证条件
    },
    slectPath (item) {
      // console.log(item)
      this.pathInfo.pipeName = item.pipeName
    },
    addPath (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_this.index === '') return
          if (_this.pathInfo.ratio === '') {
            _this.pathInfo.ratio = 0
          }
          let op = Object.assign({}, _this.pathInfo) // 复制保存信息，关闭弹窗后防止清空信息
          for (let v of _this.pathTable[_this.index].table) {
            if (op.pipeId === v.pipeId) {
              _this.$message.error('请勿选择相同通道!')
              return
            }
          }
          op.groupIndex = _this.pathTable[_this.index].table.length + 1 // 增加排序的优先级
          op.pipeType = Number(op.pipeType) // 转化数字
          op.active = Number(op.active) // 转化数字
          // _this.pathTable[_this.index].table.push(op) // 往通道组添加关联通道
          // _this.pathTable = _this.pathTable.slice(0)
          _this.$store.commit('addPromain/addPath', op)
          // console.log(_this.pathTable)
          _this.pathDialog = false
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    editPath (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_this.index === '' || _this.channelIndex === '') return
          if (_this.pathInfo.ratio === '') {
            _this.pathInfo.ratio = 0
          }
          let op = Object.assign({}, _this.pathTable[_this.index].table[_this.channelIndex], _this.pathInfo) // 复制保存信息，关闭弹窗后防止清空信息
          for (let i = 0; i < _this.pathTable[_this.index].table.length; i++) {
            if (_this.channelIndex !== i) {
              if (op.pipeId === _this.pathTable[_this.index].table[i].pipeId) {
                _this.$message.error('请勿选择相同通道!')
                return
              }
            }
          }
          _this.pathTable[_this.index].table.splice(_this.channelIndex, 1, op) // 往通道组替换关联通道
          _this.pathTable[_this.index].table.forEach((v, i) => {
            v.groupIndex = i + 1 // 增加排序的优先级
            v.pipeType = Number(v.pipeType) // 转化数字
            v.active = Number(v.active) // 转化数字
          })
          _this.pathDialog = false
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    addGroup (formName) { // 添加通道组
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.prodId = _this.prodId
          op.groupName = _this.pathGroupInfo.groupName
          op.status = Number(_this.pathGroupInfo.state)
          if (_this.pathGroupInfo.cached === 'true') {
            op.cached = true
          } else {
            op.cached = false
          }
          op.desc = _this.pathGroupInfo.groupDesc
          _this.$axios({
            url: _this.$API.product.addGroup,
            method: 'post',
            data: op
          }).then((response) => {
            _this.queryPath(_this.prodId)
            _this.$root.eventHub.$emit('clear', '') // 发送消息关闭展开行
            _this.$message.success('通道组添加成功!')
            _this.pathGroupDialog = false
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    editGroup (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          op.prodId = _this.prodId
          op.groupName = _this.pathGroupInfo.groupName
          op.status = _this.pathGroupInfo.state
          if (_this.pathGroupInfo.cached === 'true') {
            op.cached = true
          } else {
            op.cached = false
          }
          op.desc = _this.pathGroupInfo.groupDesc
          op.groupId = _this.groupId
          _this.$axios({
            url: _this.$API.product.editGroup,
            method: 'post',
            data: op
          }).then((response) => {
            _this.queryPath(_this.prodId)
            _this.$root.eventHub.$emit('clear', '') // 发送消息关闭展开行
            _this.$message.success('通道组编辑成功!')
            _this.pathGroupDialog = false
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    delGroup (op) {
      let _this = this
      let data = {}
      data.groupName = op.row.groupName
      data.groupId = op.row.groupId
      data.prodId = this.prodId
      this.$confirm('此操作将永久删除该通道组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: _this.$API.product.delProdGroupInfo,
          data: data
        }).then((response) => {
          if (response.data.resCode === 1) {
            _this.$root.eventHub.$emit('clear', '') // 发送消息关闭展开行
            _this.$message.success('通道组删除成功!')
            _this.queryPath(_this.prodId)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    reletedCusGroup (val) { // 查询已关联客户
      let _this = this
      let op = {}
      op.groupId = val.row.groupId
      op.prodId = this.prodId
      this.$axios({
        url: _this.$API.product.queryCustListByGroup,
        method: 'post',
        data: op
      }).then((response) => {
        if (response.data.resData) {
          _this.CusGroupData = response.data.resData
          _this.releteGroupDialog = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    relatedPath () {
      this.reletedGroup = true
      this.pathGroupTitle = '添加通道组'
      this.pathGroupDialog = true
    },
    editPathGroup (op) {
      this.reletedGroup = false
      this.pathGroupTitle = '编辑通道组'
      this.pathGroupInfo.groupName = op.row.groupName
      if (op.row.groupName === 'default') {
        this.groupNameDisabled = true
      }
      this.groupId = op.row.groupId
      this.pathGroupInfo.state = op.row.status + ''
      this.pathGroupInfo.cached = op.row.cached + ''
      this.pathGroupInfo.groupDesc = op.row.groupDesc
      this.pathGroupDialog = true
    },
    relatedRule () {
      if (!this.showRule) {
        this.showRule = true
        this.queryStr() // 请求计价策略
      }
    },
    submitForm (formName) { // 编辑保存产品
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          if (_this.proInfo.sysId) {
            sysIds.push(_this.proInfo.sysId)
          }
          op.sysIds = sysIds
          op.prodZhName = _this.proInfo.proName
          op.prodEnName = _this.proInfo.proEngName
          op.prodTypeId = _this.proInfo.proType
          if (_this.proInfo.proAlarm === 'true') {
            op.needAlarm = true
          } else {
            op.needAlarm = false
          }
          if (_this.proInfo.alarmPath.length === 2) {
            op.alarmType = '0,1'
          } else if (_this.proInfo.alarmPath.length === 1) {
            if (_this.proInfo.alarmPath[0] === '短信') {
              op.alarmType = '0'
            } else {
              op.alarmType = '1'
            }
          } else {
            op.alarmType = ''
          }
          if (_this.proInfo.proCache === 'true') {
            op.cached = true
          } else {
            op.cached = false
          }
          op.cached = false
          op.cacheExpireTime = 0
          if (op.cached && (!op.cacheExpireTime || op.cacheExpireTime === 0)) {
            _this.$message.error('缓存时间必须大于0!')
            return
          }
          if (_this.proInfo.proState === 'false') {
            op.turnOff = false
          } else {
            op.turnOff = true
          }
          op.prodDesc = _this.proInfo.desc
          op.prodId = _this.prodId
          op.alarmTimeout = _this.proInfo.alarmTime
          op.serviceTimeout = _this.proInfo.proTimeout
          _this.$axios({
            url: _this.$API.product.updateProdInfo,
            method: 'post',
            data: op
          }).then((response) => {
            _this.$message.success('产品更新成功!')
            if (op.cached) {
              _this.cachedDisabled = false
            } else {
              _this.cachedDisabled = true
              _this.pathGroupInfo.cached = 'false'
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    addForm (formName) { // 新增产品
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          if (_this.proInfo.sysId) {
            sysIds.push(_this.proInfo.sysId)
          }
          op.sysIds = sysIds
          op.prodZhName = _this.proInfo.proName
          op.prodEnName = _this.proInfo.proEngName
          op.prodTypeId = _this.proInfo.proType
          if (_this.proInfo.proAlarm === 'true') {
            op.needAlarm = true
          } else {
            op.needAlarm = false
          }
          if (_this.proInfo.alarmPath.length === 2) {
            op.alarmType = '0,1'
          } else if (_this.proInfo.alarmPath.length === 1) {
            if (_this.proInfo.alarmPath[0] === '短信') {
              op.alarmType = '0'
            } else {
              op.alarmType = '1'
            }
          } else {
            op.alarmType = ''
          }
          if (_this.proInfo.proCache === 'true') {
            op.cached = true
          } else {
            op.cached = false
          }
          op.cached = false
          op.cacheExpireTime = 0
          if (op.cached && (!op.cacheExpireTime || op.cacheExpireTime === 0)) {
            _this.$message.error('缓存时间必须大于0!')
            return
          }
          if (_this.proInfo.proState === 'false') {
            op.turnOff = false
          } else {
            op.turnOff = true
          }
          op.prodDesc = _this.proInfo.desc
          // op.prodId = _this.prodId
          op.alarmTimeout = _this.proInfo.alarmTime
          op.serviceTimeout = _this.proInfo.proTimeout
          console.log(op)
          _this.$axios({
            url: _this.$API.product.addProdInfo,
            method: 'post',
            data: op
          }).then((response) => {
            console.log(response.data)
            _this.$store.commit('addPromain/changeProdId', response.data.resData.prodId) // 给proId 赋值
            _this.queryStr() // 请求计价策略
            _this.related = true
            _this.path = true
            _this.tabDisabled = false
            _this.showRule = true
            _this.activeName = 'fource'
            _this.queryPath(_this.prodId)
            _this.queryFiled(_this.prodId)
            _this.tabFirstDisabled = true
            _this.$message.success('云端产品新增成功!')
            if (op.cached) {
              _this.cachedDisabled = false
            } else {
              _this.cachedDisabled = true
              _this.pathGroupInfo.cached = 'false'
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    queryFiled (id) { // 查询产品关联计价字段
      let _this = this
      this.$axios({
        url: _this.$API.product.queryChargeFieldsByProdId,
        // url: 'http://172.16.6.77:5010/agw/prodCtr/queryChargeFieldsByProdId',
        method: 'post',
        data: { prodId: id }
      }).then((response) => {
        _this.proBillFiled.billFiledData = response.data.resData
        _this.copyFieldData = response.data.resData
        console.log(_this.proBillFiled.billFiledData)
      }).catch((err) => {
        console.log(err)
      })
    },
    queryPro (val) { // 请求产品信息
      let _this = this
      this.$axios({
        url: _this.$API.product.queryProdInfo,
        method: 'post',
        data: { prodId: val }
      }).then((response) => {
        if (response.data.resData) {
          let data = response.data.resData
          _this.proInfo.sysId = Number(data.sysId)
          _this.proInfo.proName = data.prodZhName
          _this.proInfo.proEngName = data.prodEnName
          _this.proInfo.proType = data.prodTypeId
          _this.proInfo.proState = data.turnoff + ''
          _this.proInfo.proCache = data.cached + ''
          if (data.cached) {
            _this.timeDisabled = false
            _this.cachedDisabled = false
          } else {
            _this.timeDisabled = true
            _this.cachedDisabled = true
            _this.pathGroupInfo.cached = 'false'
          }
          _this.proInfo.time = data.cacheExpireTime
          _this.proInfo.proAlarm = data.needAlarm + ''
          if (data.needAlarm) {
            _this.alarmDisabled = false
          } else {
            _this.alarmDisabled = true
          }
          if (data.alarmType === '0,1') {
            _this.proInfo.alarmPath = ['短信', '邮箱']
          } else if (data.alarmType === '0') {
            _this.proInfo.alarmPath = ['短信']
          } else if (data.alarmType === '1') {
            _this.proInfo.alarmPath = ['邮箱']
          } else {
            _this.proInfo.alarmPath = []
          }
          _this.proInfo.alarmTime = data.alarmTimeout
          _this.proInfo.proTimeout = data.serviceTimeout
          _this.proInfo.desc = data.prodDesc
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    queryStr () { // 请求计价策略
      let _this = this
      this.$axios({
        method: 'post',
        url: _this.$API.product.queryStrategyList
      }).then((response) => {
        if (response.data.resData) {
          _this.priceRule.strategy = response.data.resData
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    queryRule (op) { // 请求计价规则
      console.log(this.copyFieldData)
      this.singleData = {
        inputParamsPricing: {
          inputParamsPricingFlag: false
          // pricingunit: [
          //   {
          //     key: '',
          //     value: ''
          //   }
          // ]
        },
        outputParamsPricings: [
          {
            outputParamsPricing: {
              pricing: [
                {
                  type: '', // 等于大于那列
                  key: '',
                  value: ''
                }
              ],
              price: ''
            }
          }
        ]
      }
      this.amountData = { // 金额 调用 规则数据
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              start: '',
              end: '',
              price: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      }
      this.packetData = { // 包时段
        inputParamsPricing: {},
        outputParamsPricings: {
          section: [
            {
              // start: '2019-01-22',
              // end: '2019-01-25',
              time: [], // 需要把start和end合并到time数组
              price: '',
              expectPrice: ''
            }
          ],
          outputParamsPricing: [
            {
              pricing: [
                {
                  type: '',
                  key: '',
                  value: ''
                }
              ]
            }
          ]
        }
      }
    },
    queryBill (op) { // 获取计价字段
      let _this = this
      this.$axios({
        method: 'get',
        url: _this.$API.product.queryInterfaceParamInfoByAll
      }).then((response) => {
        if (!op.ruleFields) return
        _this.priceRule.billArr = []
        for (var v of op.ruleFields) {
          let obj = {}
          obj.billKeyWord = ''
          obj.billParamName = ''
          obj.billKeyWordType = ''
          for (var val of response.data.resData.paramNameList) {
            if (v.key === val.paramIdentify) {
              obj.billParamName = val.paramName
              obj.billKeyWordType = val.interfaceParamId
              obj.billKeyWord = ''
            }
          }
          _this.priceRule.billArr.push(obj)
          _this.priceRule.disabled = false
        }
        if (!_this.priceRule.billArr.length) {
          _this.priceRule.billArr = [
            {
              billKeyWord: '',
              billParamName: '',
              billKeyWordType: ''
            }
          ]
          _this.priceRule.disabled = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    queryProRule (id) { // 请求产品关联计价规则
      let _this = this
      let getStr = () => {
        return _this.$axios({
          method: 'post',
          url: _this.$API.product.queryStrategyList
        })
      }
      let getProStr = () => {
        return _this.$axios({
          url: _this.$API.product.queryChargeRule,
          method: 'post',
          data: { prodId: id }
        })
      }
      let getBill = () => {
        return this.$axios({
          method: 'get',
          url: _this.$API.product.queryInterfaceParamInfoByAll
        })
      }
      this.$axios.all([getStr(), getProStr(), getBill()])
        .then(_this.$axios.spread(function (getStr, getProStr, getBill) {
          // 两个请求现在都执行完成
          if (getStr.data.resData) {
            _this.priceRule.strategy = getStr.data.resData
          }
          if (getProStr.data.resData && getProStr.data.resData.chargeRulePolicyId) {
            _this.priceRule.strategyId = getProStr.data.resData.chargeRulePolicyId
          }
          if (!_this.priceRule.strategyId) return
          _this.$axios({ // 请求计价规则
            method: 'get',
            params: { strategyId: _this.priceRule.strategyId },
            url: _this.$API.product.queryRuleUnusedByStrategyId
          }).then((response) => {
            console.log(response.data)
            // _this.priceRule.rule = response.data.resData
            if (getProStr.data.resData.ruleNameCn) {
              let op = {}
              op.ruleNameCn = getProStr.data.resData.ruleNameCn
              op.ruleId = getProStr.data.resData.ruleId
              _this.priceRule.rule.push(op)
              for (let v of response.data.resData) {
                _this.priceRule.rule.push(v)
              }
              _this.priceRule.ruleId = op.ruleId
            }
            let obj = getProStr.data.resData
            if (!obj.mappingFields) return
            _this.priceRule.billArr = []
            console.log(getBill)
            for (var v of obj.mappingFields) {
              let o = {}
              o.billKeyWord = ''
              o.billParamName = ''
              o.billKeyWordType = ''
              for (var val of getBill.data.resData.paramNameList) {
                if (v.mappingParamId === val.interfaceParamId) {
                  o.billParamName = val.paramName
                  o.billKeyWordType = val.interfaceParamId
                  o.billKeyWord = v.billKeyWord
                }
              }
              _this.priceRule.billArr.push(o)
              _this.priceRule.disabled = false
            }
            if (!_this.priceRule.billArr.length) {
              _this.priceRule.billArr = [
                {
                  billKeyWord: '',
                  billParamName: '',
                  billKeyWordType: ''
                }
              ]
              _this.priceRule.disabled = true
            }
          }).catch((err) => {
            console.log(err)
          })
        }))
    },
    queryPath (id) { // 请求通道组
      let op = {
        pageNum: this.currentPage,
        pageSize: this.page,
        prodId: id
      }
      this.$store.dispatch('addPromain/getPathTable', op)
    },
    queryPipe () { // 请求所有通道
      let _this = this
      this.$axios({
        url: _this.$API.product.queryPipesList,
        method: 'get',
        params: {
          param: { pipeIdList: [] }
        }
      }).then((response) => {
        _this.pipeIdList = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
    },
    httpChannel (val) { // 请求通道组关联通道
      let op = {}
      let _this = this
      op.prodId = this.prodId
      op.groupId = val.groupId
      this.$axios({
        url: _this.$API.product.queryPipeListByGroup,
        method: 'post',
        data: op
      }).then((response) => {
        if (response.data.resData && response.data.resData.prodPipeRefList) {
          let arr = response.data.resData.prodPipeRefList
          _this.pathTable[val.index].table.splice(0, _this.pathTable[val.index].table.length) // 每次重新请求清空
          arr.forEach((item) => {
            _this.pathTable[val.index].table.push(item)
          })
          _this.$root.eventHub.$emit('test', 'dd')
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    httpGroup (val) {
      let op = {}
      op.groupId = val.groupId
      op.prodId = this.prodId
      let _this = this
      this.$axios({
        url: _this.$API.product.queryAvailablePipeListByProdGroupId,
        method: 'post',
        data: op
      }).then((response) => {
        _this.pipeIdList = response.data.resData
        _this.copypipeIdList = response.data.resData
      }).catch((err) => {
        console.log(err)
      })
    },
    saveFiled () {
      let _this = this
      let op = {}
      op.prodId = this.prodId
      op.fields = this.proBillFiled.billFiledData
      for (let i = 0; i < this.proBillFiled.billFiledData.length; i++) {
        for (let j = i + 1; j < this.proBillFiled.billFiledData.length; j++) {
          if (this.proBillFiled.billFiledData[i].fieldId === this.proBillFiled.billFiledData[j].fieldId) {
            this.$message.error('计费字段不能相同!')
            return
          }
        }
      }
      this.$axios({
        url: _this.$API.product.assignChargeFieldsByProdId,
        // url: 'http://172.16.6.77:5010/agw/prodCtr/assignChargeFieldsByProdId',
        method: 'post',
        data: op
      }).then((response) => {
        _this.copyFieldData = op.fields
        _this.activeName = 'second'
        _this.$message.success('计费字段关联成功!')
      }).catch((err) => {
        console.log(err)
      })
    },
    addRule () { // 保存计价规则
      let op = {}
      let fieldIds = []
      let _this = this
      op.prodId = this.prodId
      op.ruleNameCn = this.priceRule.ruleNameCn
      op.ruleNameEn = this.priceRule.ruleNameCn
      op.strategyId = this.priceRule.strategyId
      if (!op.ruleNameCn) {
        _this.$message.error('计价规则不能为空!')
        return
      }
      if (!op.strategyId) {
        _this.$message.error('计价策略不能为空!')
        return
      }
      let ruleJson = {}
      if (_this.priceRule.strategyId === '20171020110707_Yr2r1x61_1000002') { // 单次计价
        console.log('ss')
        ruleJson.inputParamsPricing = {}
        ruleJson.inputParamsPricing.pricingunit = []
        ruleJson.inputParamsPricing.inputParamsPricingFlag = this.singleData.inputParamsPricing.inputParamsPricingFlag
        if (ruleJson.inputParamsPricing.inputParamsPricingFlag) {
          for (let k of this.singleData.inputParamsPricing.pricingunit) {
            let o = {}
            let key = k.key
            if (key === '') {
              this.$message({
                message: '附加入参计费参数不能为空!',
                type: 'warning'
              })
              return
            }
            o[key] = '\"' + k.value + '\"'
            if (k.value === '') {
              this.$message({
                message: '价格不能为空!',
                type: 'warning'
              })
              return
            }
            ruleJson.inputParamsPricing.pricingunit.push(o)
          }
        }
        ruleJson.outputParamsPricings = []
        for (let v of this.singleData.outputParamsPricings) {
          let obj = {}
          obj.outputParamsPricing = {}
          if (v.outputParamsPricing.price === '') {
            this.$message({
              message: '价格不能为空!',
              type: 'warning'
            })
            return
          }
          obj.outputParamsPricing.pricing = []
          for (let i of v.outputParamsPricing.pricing) {
            let opSingle = {}
            opSingle.type = i.type
            let key = i.key
            opSingle[key] = '\"' + i.value + '\"'
            if (i.value === '') {
              this.$message({
                message: '计价值不能为空!',
                type: 'warning'
              })
              return
            }
            if (i.type === '') {
              this.$message({
                message: '输入不能为空!',
                type: 'warning'
              })
              return
            }
            for (let p of _this.copyFieldData) {
              if (i.key === p.fieldName) {
                fieldIds.push(p.fieldId)
              }
            }
            obj.outputParamsPricing.pricing.push(opSingle)
          }
          obj.outputParamsPricing.price = v.outputParamsPricing.price
          ruleJson.outputParamsPricings.push(obj)
        }
      } else if (_this.priceRule.strategyId === '20171020110707_Yr2r1x61_1000001' || this.priceRule.strategyId === '20171020110707_Yr2r1x61_1000000') { // 金额 调用量
        ruleJson.inputParamsPricing = {}
        ruleJson.outputParamsPricings = {}
        ruleJson.outputParamsPricings.section = this.amountData.outputParamsPricings.section
        let verification = true
        let priceVer = false
        console.log(this.amountData.outputParamsPricings.section)
        this.amountData.outputParamsPricings.section.forEach((item, index) => {
          if (item.end && item.start && item.start !== 0 && item.end !== 0) {
            if (parseInt(item.end.replace(/-/g, '')) > parseInt(item.start.replace(/-/g, ''))) {
              verification = true
              if (index > 0) {
                if (parseInt(item.start.replace(/-/g, '')) >= parseInt(this.amountData.outputParamsPricings.section[index - 1].end.replace(/-/g, ''))) {
                  verification = true
                } else {
                  verification = false
                }
              }
            }
          } else {
            verification = false
          }
          if (item.price === '') {
            priceVer = true
          }
        })
        if (!verification) {
          this.$message({
            message: '区间不能有交集!',
            type: 'warning'
          })
          return
        }
        if (priceVer) {
          this.$message({
            message: '价格不能为空!',
            type: 'warning'
          })
          return
        }
        ruleJson.outputParamsPricings.outputParamsPricing = []
        for (let v of this.amountData.outputParamsPricings.outputParamsPricing) {
          let opAmount = {}
          opAmount.pricing = []
          for (let o of v.pricing) {
            let op = {}
            op.type = o.type
            let key = o.key
            op[key] = '\"' + o.value + '\"'
            if (o.value === '') {
              this.$message({
                message: '计价值不能为空!',
                type: 'warning'
              })
              return
            }
            if (o.type === '') {
              this.$message({
                message: '输入不能为空!',
                type: 'warning'
              })
              return
            }
            for (let p of _this.copyFieldData) {
              if (key === p.fieldName) {
                fieldIds.push(p.fieldId)
              }
            }
            opAmount.pricing.push(op)
          }
          ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
        }
      } else if (_this.priceRule.strategyId === '20171020110707_Yr2r1x61_1000003') { // 包时段
        ruleJson.inputParamsPricing = {}
        ruleJson.outputParamsPricings = {}
        ruleJson.outputParamsPricings.section = []
        for (let k of this.packetData.outputParamsPricings.section) {
          let secOP = {}
          if ((k.time && !k.time.length) || !k.time) {
            this.$message({
              message: '区间不能为空!',
              type: 'warning'
            })
            return
          }
          secOP.start = k.time[0]
          secOP.end = k.time[1]
          secOP.price = k.price
          secOP.expectPrice = k.expectPrice
          if (k.price === '') {
            this.$message({
              message: '价格不能为空!',
              type: 'warning'
            })
            return
          }
          if (k.expectPrice === '') {
            this.$message({
              message: '预付成本不能为空!',
              type: 'warning'
            })
            return
          }
          ruleJson.outputParamsPricings.section.push(secOP)
        }
        let verification = true
        ruleJson.outputParamsPricings.section.forEach((item, index) => {
          if (parseInt(item.end.replace(/-/g, '')) > parseInt(item.start.replace(/-/g, ''))) {
            if (index > 0) {
              if (parseInt(item.start.replace(/-/g, '')) >= parseInt(ruleJson.outputParamsPricings.section[index - 1].end.replace(/-/g, ''))) {
                verification = true
              } else {
                verification = false
              }
            }
          } else {
            verification = false
          }
        })
        if (!verification) {
          this.$message({
            message: '区间不能有交集!',
            type: 'warning'
          })
          return
        }
        ruleJson.outputParamsPricings.outputParamsPricing = []
        for (let v of this.packetData.outputParamsPricings.outputParamsPricing) {
          let opAmount = {}
          opAmount.pricing = []
          for (let o of v.pricing) {
            let op = {}
            op.type = o.type
            let key = o.key
            op[key] = '\"' + o.value + '\"'
            if (o.value === '') {
              this.$message({
                message: '计价值不能为空!',
                type: 'warning'
              })
              return
            }
            if (o.type === '') {
              this.$message({
                message: '输入不能为空!',
                type: 'warning'
              })
              return
            }
            for (let p of _this.copyFieldData) {
              if (key === p.fieldName) {
                fieldIds.push(p.fieldId)
              }
            }
            opAmount.pricing.push(op)
          }
          ruleJson.outputParamsPricings.outputParamsPricing.push(opAmount)
        }
      }
      console.log(ruleJson)
      console.log(fieldIds)
      ruleJson = JSON.stringify(ruleJson)
      op.fieldIds = fieldIds
      op.ruleJson = ruleJson
      this.$axios({
        url: _this.$API.product.assignChargeRuleByProdId,
        // url: 'http://172.16.6.77:5010/agw/prodCtr/assignChargeRuleByProdId',
        method: 'post',
        data: op
      }).then((response) => {
        _this.activeName = 'third'
        _this.$message.success('产品关联计价成功!')
      }).catch((err) => {
        console.log(err)
      })
    },
    hideRule () {
      this.showRule = false
    },
    selectCache (val) { // 是否缓存
      if (val === 'true') {
        this.timeDisabled = false
        this.proInfo.time = ''
      } else {
        this.timeDisabled = true
        this.proInfo.time = 0
      }
    },
    selectAlarm (val) { // 选择是否需要告警通道
      console.log()
      if (val === 'true') {
        this.alarmDisabled = false
      } else {
        this.alarmDisabled = true
        this.proInfo.alarmPath = []
      }
    }
  },
  created () {
    let _this = this
    if (this.$route.query.num) {
      this.num = this.$route.query.num
      this.size = this.$route.query.size
    }
    async function queryData () {
      let querySys = () => {
        _this.$store.dispatch('getSystem') // 请求业务系统
      }
      // let queryType = () => {
      //   // if (!_this.typeData.length) { // 是否请求产品类型 如果为空则请求
      //   //   _this.$store.dispatch('getProductType')
      //   // } else {
      //   //   return Promise.resolve('success')
      //   // }
      //   _this.axios({
      //     method: 'post',
      //     url: _this.$API.product.getProdTypeList,
      //     data: { 'pageNum': 1, 'pageSize': 50 }
      //   }).then((response) => {
      //     _this.typeData = response.data.resData.resultList
      //   }).catch((error) => {
      //     console.log(error)
      //   })
      // }
      let proId = _this.$route.query.id // 编辑产品id
      await Promise.all([querySys()])
      // _this.queryPipe()
      if (proId) {
        _this.queryPro(proId)
        _this.title = '编辑云端产品'
        _this.showRule = true
        _this.related = true
        _this.path = true
        _this.$store.commit('addPromain/changeProdId', proId) // 给proId 赋值
        _this.editSure = true
        _this.queryProRule(proId)
        _this.queryPath(proId)
      } else {
        _this.title = '新增云端产品'
        _this.editSure = false
      }
    }
    queryData()
    // console.log()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/proManage/addProMain.vue